/**
 * Created by Denis Kuzin on 29 march 2022
 */

const MyClanWindow = BaseClanWindow.extend({
    ctor: function (options) {
        options = options || {};

        this.updateTop = true;
        this.updateMessages = true;

        this._super(options);
    },

    onWindowLoaded: function (options) {
        this._super({
            clan: cleverapps.userClan,
            name: "MyClanWindow",
            title: Messages.get("ClansWindow.chat.title")
        });

        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.CLANS_DAU);
        if (options.hasReq) {
            this.tabs.activateTab(0);
        }
    },

    createTabs: function () {
        return {
            0: {
                icon: bundles.clan.frames.tab_icon_chat_team,
                text: Messages.get("ClansWindow.chat.title"),
                generator: this.createTab.bind(this, ClansChatTab),
                updateTitle: this.setTitle.bind(this, Messages.get("ClansWindow.chat.title"))
            },
            1: {
                icon: bundles.clan.frames.tab_icon_my_team,
                text: Messages.get("ClansWindow.team.title"),
                generator: this.createTab.bind(this, ClansInfoTab),
                updateTitle: this.setTitle.bind(this, Messages.get("ClansWindow.team.title"))
            },
            2: {
                icon: bundles.clan.frames.tab_icon_top_team,
                text: Messages.get("ClansWindow.top.title"),
                generator: this.createTab.bind(this, ClansTopTab),
                updateTitle: this.setTitle.bind(this, Messages.get("ClansWindow.top.title"))
            }
        };
    }
});